import React, { useCallback, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import Dropdown from '@ecp/common/src/components/dropdown/bo/Dropdown';
import SearchInput from '@ecp/common/src/components/input/bo/SearchInput';

import { useAlertDialog } from '@bo-hooks/common/useModal';
import { DEFAULT_SEARCH_CONDITION, SEARCH_CONDITION, SEARCH_CONDITION_FOR_BO, SEARCH_CONDITION_KEY } from './const';
import { isPODomain } from '@bo-const/common/domain';

const Container = styled(FlexBox)`
  padding-left: 30px;
  background-color: transparent;
  width: fit-content;
  height: fit-content;
`;

const GnbSearch = () => {
  const [searchDropdownValue, setSearchDropdownValue] = useState(DEFAULT_SEARCH_CONDITION);
  const [searchKeyword, setSearchKeyword] = useState('');
  const searchInputRef = useRef(null);

  const navigate = useNavigate();
  const { showAlertDialog } = useAlertDialog();
  const handleSearchDropdownChange = (data) => {
    setSearchDropdownValue({ ...data });
  };

  const handleSearchKeywordChange = (e) => {
    setSearchKeyword(e?.target?.value ?? '');
  };

  const navigateWithSearchKeyword = useCallback(() => {
    if (!searchKeyword) {
      showAlertDialog('검색어를 입력하세요.', () => searchInputRef.current.focus());
      return;
    }
    const root = isPODomain() ? '/partner' : '';
    switch (searchDropdownValue.key) {
      case SEARCH_CONDITION_KEY.PRODUCT_NAME:
        navigate(`${root}/good/info/management`, {
          state: { searchKeyword, searchType: SEARCH_CONDITION_KEY.PRODUCT_NAME },
        });
        break;
      case SEARCH_CONDITION_KEY.PRODUCT_NUMBER:
        navigate(`${root}/good/info/management`, {
          state: { searchKeyword, searchType: SEARCH_CONDITION_KEY.PRODUCT_NUMBER },
        });
        break;
      case SEARCH_CONDITION_KEY.ORDER_NUMBER:
        navigate(`${root}/order/order-info`, {
          state: { searchKeyword, searchType: SEARCH_CONDITION_KEY.ORDER_NUMBER },
        });
        break;
      case SEARCH_CONDITION_KEY.TRACKING_NUMBER:
        navigate(`${root}/delivery/management`, {
          state: { searchKeyword, searchType: SEARCH_CONDITION_KEY.TRACKING_NUMBER },
        });
        break;
      default:
    }
  }, [searchKeyword, searchDropdownValue.key, showAlertDialog, navigate]);

  return (
    <Container>
      <Dropdown
        width="140px"
        items={isPODomain() ? SEARCH_CONDITION_FOR_BO : SEARCH_CONDITION}
        value={searchDropdownValue}
        onChange={handleSearchDropdownChange}
      />
      <Spacing left="6px" />
      <SearchInput
        value={searchKeyword}
        width="327px"
        onChange={handleSearchKeywordChange}
        onSearchClick={navigateWithSearchKeyword}
        onEnter={navigateWithSearchKeyword}
        placeholder="검색어를 입력하세요."
        ref={searchInputRef}
      />
    </Container>
  );
};

export default GnbSearch;
